function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoProfile = require('../../../lib/saito/ui/saito-profile/saito-profile');

/**
 * Red Square profile chrome: shared SaitoProfile card + RS-specific footer nav
 * (Posts / Replies / Likes + respondTo('redsquare-profile') ext links).
 */
var Profile = /*#__PURE__*/function () {
  function Profile(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Profile);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.publicKey = '';
    this.ext_links = [];
    this._nav_bound = false;
    this.saito_profile = new SaitoProfile(app, mod, container);
  }
  return _createClass(Profile, [{
    key: "collectProfileExtLinks",
    value: function collectProfileExtLinks() {
      var _this$app$modules;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var profileData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var key = String(publicKey || '').trim();
      if (!key || !((_this$app$modules = this.app.modules) !== null && _this$app$modules !== void 0 && _this$app$modules.getRespondTos)) {
        return [];
      }
      var profile = profileData && _typeof(profileData) === 'object' ? profileData : {};
      var peers = this.app.modules.getRespondTos('redsquare-profile', {
        publicKey: key,
        profile: profile
      });
      var out = [];
      var seen = new Set();
      var _iterator = _createForOfIteratorHelper(peers || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var text = String((item === null || item === void 0 ? void 0 : item.text) || '').trim();
          var link = String((item === null || item === void 0 ? void 0 : item.link) || (item === null || item === void 0 ? void 0 : item.url) || '').trim();
          if (!text || !link) {
            continue;
          }
          var id = text.toLowerCase();
          if (seen.has(id)) {
            continue;
          }
          seen.add(id);
          out.push({
            text: text,
            link: link
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return out;
    }
  }, {
    key: "renderNavHtml",
    value: function renderNavHtml() {
      var extLinks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var browser = this.app.browser;
      var escapeAttr = function escapeAttr(value) {
        return browser !== null && browser !== void 0 && browser.escapeHTML ? browser.escapeHTML(String(value !== null && value !== void 0 ? value : '')) : String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      };
      var escapeText = function escapeText(value) {
        return String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      };
      var extLinksHtml = (extLinks || []).map(function (item) {
        var _browser$isSafeHref;
        var text = escapeText(item === null || item === void 0 ? void 0 : item.text);
        var rawLink = item === null || item === void 0 ? void 0 : item.link;
        if (!text || !rawLink || !(browser !== null && browser !== void 0 && (_browser$isSafeHref = browser.isSafeHref) !== null && _browser$isSafeHref !== void 0 && _browser$isSafeHref.call(browser, rawLink))) {
          return '';
        }
        return "<a class=\"item\" href=\"".concat(escapeAttr(rawLink), "\" data-profile-ext=\"1\">").concat(text, "</a>");
      }).join('');
      return "\n      <nav class=\"nav redsquare-profile-nav\" aria-label=\"Posts, replies, and likes\">\n        <div class=\"item\" role=\"link\" tabindex=\"0\" data-profile-nav=\"posts\">Posts</div>\n        <div class=\"item\" role=\"link\" tabindex=\"0\" data-profile-nav=\"replies\">Replies</div>\n        <div class=\"item\" role=\"link\" tabindex=\"0\" data-profile-nav=\"likes\">Likes</div>\n        ".concat(extLinksHtml, "\n      </nav>\n    ");
    }
  }, {
    key: "syncProfileExtLinks",
    value: function syncProfileExtLinks() {
      var _footer$querySelector;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var profileData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var footer = this.saito_profile.getFooterEl();
      var nav = footer === null || footer === void 0 || (_footer$querySelector = footer.querySelector) === null || _footer$querySelector === void 0 ? void 0 : _footer$querySelector.call(footer, '.nav');
      if (!nav) {
        return;
      }
      nav.querySelectorAll('[data-profile-ext]').forEach(function (el) {
        return el.remove();
      });
      this.ext_links = this.collectProfileExtLinks(publicKey, profileData);
      var _iterator2 = _createForOfIteratorHelper(this.ext_links),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _this$app$browser, _this$app$browser$isS;
          var item = _step2.value;
          if (!((_this$app$browser = this.app.browser) !== null && _this$app$browser !== void 0 && (_this$app$browser$isS = _this$app$browser.isSafeHref) !== null && _this$app$browser$isS !== void 0 && _this$app$browser$isS.call(_this$app$browser, item.link))) {
            continue;
          }
          var a = document.createElement('a');
          a.className = 'item';
          a.href = item.link;
          a.setAttribute('data-profile-ext', '1');
          a.textContent = item.text;
          nav.appendChild(a);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$mod$manager,
        _this = this;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (container) {
        this.container = container;
        this.saito_profile.container = container;
      }
      var key = publicKey || this.mod.publicKey || '';
      this.publicKey = key;
      this.ext_links = this.collectProfileExtLinks(key);

      // Clear host mount then render shared card into it.
      var host = document.querySelector(this.container);
      if (host) {
        host.innerHTML = '';
      }
      this.saito_profile.ordinal = 0;
      this.saito_profile.reset(key);
      this.saito_profile.container = this.container;
      this.saito_profile.render();
      var footer = this.saito_profile.getFooterEl();
      if (footer) {
        footer.innerHTML = this.renderNavHtml(this.ext_links);
      }
      this.attachNavEvents();
      this.syncActiveNav(((_this$mod$manager = this.mod.manager) === null || _this$mod$manager === void 0 ? void 0 : _this$mod$manager.mode) || 'timeline');

      // When Profile updates arrive on the shared card, refresh ext links + mod.profile cache.
      if (!this._profile_dom_hooked) {
        this._profile_dom_hooked = true;
        this.app.connection.on('profile-update-dom', function (pk, data) {
          if (!pk || !data) {
            return;
          }
          if (_this.publicKey && pk === _this.publicKey) {
            _this.syncProfileExtLinks(pk, data);
          }
          if (pk === _this.mod.publicKey && _this.mod.profile) {
            _this.mod.profile.banner = data.banner || '';
            _this.mod.profile.bio = data.description || '';
            if (data.image) {
              _this.mod.profile.avatar = data.image;
            }
          }
        });
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      // Compatibility for main.js callers; nav is bound in attachNavEvents.
      this.attachNavEvents();
    }
  }, {
    key: "attachNavEvents",
    value: function attachNavEvents() {
      var _this2 = this;
      var footer = this.saito_profile.getFooterEl();
      if (!footer || footer.dataset.redsquareNavBound) {
        return;
      }
      footer.dataset.redsquareNavBound = '1';
      footer.addEventListener('click', function (e) {
        var item = e.target.closest('.nav .item');
        if (!item || !footer.contains(item)) {
          return;
        }
        var view = item.getAttribute('data-profile-nav') || '';
        if (!view) {
          if (item.matches('a[href][data-profile-ext]')) {
            e.preventDefault();
            var href = item.getAttribute('href');
            if (!href) {
              return;
            }
            if (typeof navigateWindow === 'function') {
              navigateWindow(href);
            } else {
              window.location.assign(href);
            }
          }
          return;
        }
        e.preventDefault();
        var publicKey = _this2.publicKey || _this2.mod.publicKey || '';
        var manager = _this2.mod.manager;
        if (!manager) {
          return;
        }
        if (view === 'posts') {
          manager.renderPosts(publicKey);
        } else if (view === 'replies') {
          manager.renderReplies(publicKey);
        } else if (view === 'likes') {
          manager.renderLikes(publicKey);
        }
      });
      footer.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') {
          return;
        }
        var item = e.target.closest('.nav .item');
        if (!item || !footer.contains(item)) {
          return;
        }
        e.preventDefault();
        item.click();
      });
    }
  }, {
    key: "syncActiveNav",
    value: function syncActiveNav() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var footer = this.saito_profile.getFooterEl();
      if (!footer) {
        return;
      }
      var activeView = mode === 'posts' || mode === 'replies' || mode === 'likes' ? mode : '';
      footer.querySelectorAll('.nav .item').forEach(function (item) {
        var view = item.getAttribute('data-profile-nav') || '';
        var active = Boolean(activeView) && view === activeView;
        item.classList.toggle('active', active);
        item.setAttribute('aria-current', active ? 'page' : 'false');
      });
    }
  }]);
}();
module.exports = Profile;